import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      textAlign="center"
    >
      <Typography variant="h1" color="text.secondary" sx={{ fontSize: '6rem', fontWeight: 700 }}>
        404
      </Typography>
      <Typography variant="h5" color="text.secondary" gutterBottom>
        页面不存在
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        您访问的页面不存在或已被移除
      </Typography>
      <Button
        variant="contained"
        startIcon={<HomeIcon />}
        onClick={() => navigate('/')}
      >
        返回首页
      </Button>
    </Box>
  );
}
